import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=bf3fb176&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&lang=ts&"
export * from "./PostDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=bf3fb176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3fb176",
  null
  
)

export default component.exports